import { formatDateParam, makeRequest } from "../lib/makeRequest";
import moment from "moment";

export const unredeemedpawn_overall_v4 = (data) => {
  return makeRequest("/unredeemed-pawns/overall", {
    coveredDate: formatDateParam(data.covered_date),
  });
};

export const unredeemedpawn_cluster_v4 = (data) =>
  makeRequest(`/unredeemed-pawns/cluster/${data.clusterId}`, {
    coveredDate: formatDateParam(data.covered_date),
  });

export const unredeemedpawn_area_v4 = (data) =>
  makeRequest(`/unredeemed-pawns/area/${data.areaId}`, {
    coveredDate: formatDateParam(data.covered_date),
  });

export const unredeemedpawn_branch_v4 = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append(
    "coveredDate",
    moment(data.covered_date).format("YYYY-MM-DD")
  );
  return makeRequest(
    `/unredeemed-pawns/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
